import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAtomValue } from "jotai";
import { v2IsAuthenticatedAtom } from "@/v2/auth/store";

export function RequireAuth({ children }: { children: ReactNode }): React.JSX.Element {
  const isAuthenticated = useAtomValue(v2IsAuthenticatedAtom);
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
